import { DocumentVersionBestPracticeResultOverviewViewModel } from "@common/components/bestPracticeCheckDialog/BestPracticeCheckDialog.types.ts";

export interface ProcessDocumentSaveModel {
    fileName: string | undefined;
    name: string;
    link: string | undefined;
}

export interface ProcessDocumentRowViewModel {
    processDocumentId: string;
    fileName: string | undefined;
    name: string;
    link: string | undefined;
    documentId: string;
    dataId: string | undefined;
    created: Date;
    isTooLargeForAi: boolean;
    aiQualityAssuranceResult?: DocumentVersionBestPracticeResultOverviewViewModel;
}

export class ProcessDocument {
    documentId: string;
    fileName: string;
    name: string;
    link: string;

    constructor() {
        this.documentId = "";
        this.fileName = "";
        this.name = "";
        this.link = "";
    }
}

export class ProcessDocumentViewModel {
    name: string | undefined = undefined;

    constructor(name: string | undefined) {
        this.name = name;
    }
}
